define('models/pages/wishlist/wishes/page',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var WishlistPage = Model.extend({
        defaults: {
            items: [
                {
                    active: true,
                    expireDate: '10.12.2016',
                    countryCode: 'nl',
                    vendorCountry: 'NLD',
                    sellerNames: 'MARK FLOWERS...',
                    sellerNamesFull: 'MARK FLOWERS, ALB VAN EGMOND',
                    vendorNames: 'MARK FLOWERS',
                    type: 'ROSE',
                    name: 'FREEDOM',
                    length: '70, 80, 90',
                    price: '0.52',
                    minLot: '50',
                    alertCount: 10
                },
                {
                    active: true,
                    expireDate: '10.12.2016',
                    countryCode: 'nl',
                    vendorCountry: 'NLD',
                    sellerNames: 'MARK FLOWERS',
                    vendorNames: 'Все',
                    type: 'ROSE',
                    name: 'DEEP PURPLE..',
                    nameFull: 'DEEP PURPLE, FREEDOM',
                    length: 'Все',
                    price: '0.52',
                    minLot: '50',
                    alertCount: 0
                },
                {
                    active: false,
                    expireDate: '10.12.2016',
                    countryCode: 'ec',
                    vendorCountry: 'ECU',
                    sellerNames: 'Избранные',
                    vendorNames: 'MARK FLOWERS',
                    type: 'ROSE',
                    name: 'Все',
                    length: '80',
                    price: '0.52',
                    minLot: '100',
                    alertCount: 4
                }

            ],

            detail: {
                items: [
                    {
                        receiveDate: '19 фев',
                        tradeArea: 'NLD 14.2',
                        sellerName: 'ALB VAN EGMOND',
                        name: 'ROSE FREEDOM (ECOROSES)',
                        price: '0.5 USD',
                        amount: '2000 шт',
                        minLot: '100 шт',
                    },
                    {
                        receiveDate: '19 фев',
                        tradeArea: 'NLD 14.2',
                        sellerName: 'ALB VAN EGMOND',
                        name: 'ROSE FREEDOM (ECOROSES)',
                        price: '0.5 USD',
                        amount: '2000 шт',
                        minLot: '100 шт',
                    },
                    {
                        receiveDate: '19 фев',
                        tradeArea: 'NLD 14.2',
                        sellerName: 'ALB VAN EGMOND',
                        name: 'ROSE FREEDOM',
                        price: '0.5 USD',
                        amount: '2000 шт',
                        minLot: '100 шт',
                    },
                    {
                        receiveDate: '19 фев',
                        tradeArea: 'NLD 14.2',
                        sellerName: 'ALB VAN EGMOND',
                        name: 'ROSE FREEDOM',
                        price: '0.5 USD',
                        amount: '2000 шт',
                        minLot: '100 шт',
                    },
                    {
                        receiveDate: '19 фев',
                        tradeArea: 'NLD 14.2',
                        sellerName: 'ALB VAN EGMOND',
                        name: 'ROSE FREEDOM',
                        price: '0.5 USD',
                        amount: '2000 шт',
                        minLot: '100 шт',
                    }
                ]
            }
        },
        constructor: function() {
            Model.apply(this, arguments);
        },
        parse: function(data){
            return data;
        },
        dispose: function() {
            if (this.disposed) { return; }
            Model.prototype.dispose.apply(this, arguments);
        }
    });

    return WishlistPage;
});




